'use client';

import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const PersonalAIContext = createContext(null);

/**
 * PersonalAIProvider
 * Manages shared state for the Personal AI Chat panel.
 * Access-Check obsolet entfernt (2026-07-19) — Rechte via Rechtegruppen-Enforcement.
 * Listens for 'personal-ai:toggle' CustomEvent from header button.
 */
export function PersonalAIProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  // OBSOLET entfernt (2026-07-19): der /api/ai/personal/access-check-Roundtrip
  // ist raus — Zugriff wird zentral über das Rechtegruppen-Enforcement gesteuert
  // (Rule: area-rights-enforcement.md). hasAccess bleibt fuer Consumer-Kompat true.
  const hasAccess = true;

  const openPanel = useCallback(() => setIsOpen(true), []);
  const closePanel = useCallback(() => setIsOpen(false), []);
  const togglePanel = useCallback(() => setIsOpen(prev => !prev), []);

  // Listen for CustomEvent from header button (outside provider context)
  useEffect(() => {
    const handleToggle = () => setIsOpen(prev => !prev);
    window.addEventListener('personal-ai:toggle', handleToggle);
    return () => window.removeEventListener('personal-ai:toggle', handleToggle);
  }, []);

  return (
    <PersonalAIContext.Provider value={{
      isOpen,
      hasAccess,
      openPanel,
      closePanel,
      togglePanel,
    }}>
      {children}
    </PersonalAIContext.Provider>
  );
}

export function usePersonalAI() {
  const ctx = useContext(PersonalAIContext);
  if (!ctx) {
    throw new Error('usePersonalAI must be used within PersonalAIProvider');
  }
  return ctx;
}
